/**
 * MoreContent – SVG icon.
 */
import Colors from '@shared/assets/style/default/color';
import Props from '@shared/types/props/pressable';
import Screen from '@screen';

/** More content indicator. */
export default function MoreContentIcon({ focused, height, width }: Props) {
  const color = Colors['menu']['icon'][focused ? 'focused' : 'unfocused'];
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width || 24 * Screen.widthRatio}
      height={height || 23 * Screen.widthRatio}
      viewBox={`0 0 ${24 * Screen.widthRatio} ${23 * Screen.widthRatio}`}
      fill='none'
    >
      <path
        d='M19.3906 10.7813H15.4282C13.4568 10.7813 12.5054 9.84216 12.5054 7.9255V4.05383C12.5054 2.12758 13.4666 1.198 15.4282 1.198H19.3906C21.3621 1.198 22.3134 2.13716 22.3134 4.05383V7.9255C22.3134 9.84216 21.3523 10.7813 19.3906 10.7813ZM15.4282 2.6355C14.2708 2.6355 13.9766 2.923 13.9766 4.05383V7.9255C13.9766 9.05633 14.2708 9.34383 15.4282 9.34383H19.3906C20.548 9.34383 20.8422 9.05633 20.8422 7.9255V4.05383C20.8422 2.923 20.548 2.6355 19.3906 2.6355H15.4282Z'
        fill={color}
        stroke={color}
        strokeWidth={focused ? 1 : 0.5}
        strokeLinejoin='round'
        strokeLinecap='round'
      />
      <path
        d='M8.11086 10.7813H4.14839C2.17697 10.7813 1.22559 9.92842 1.22559 8.16508V3.81425C1.22559 2.05091 2.18678 1.198 4.14839 1.198H8.11086C10.0823 1.198 11.0337 2.05091 11.0337 3.81425V8.1555C11.0337 9.92841 10.0725 10.7813 8.11086 10.7813ZM4.14839 2.6355C2.83411 2.6355 2.6968 2.99966 2.6968 3.81425V8.1555C2.6968 8.97966 2.83411 9.33425 4.14839 9.33425H8.11086C9.42514 9.33425 9.56245 8.97008 9.56245 8.1555V3.81425C9.56245 2.99008 9.42514 2.6355 8.11086 2.6355H4.14839Z'
        fill={color}
        stroke={color}
        strokeWidth={focused ? 1 : 0.5}
        strokeLinejoin='round'
        strokeLinecap='round'
      />
      <path
        d='M8.11086 21.8021H4.14839C2.17697 21.8021 1.22559 20.8629 1.22559 18.9463V15.0746C1.22559 13.1483 2.18678 12.2188 4.14839 12.2188H8.11086C10.0823 12.2188 11.0337 13.1579 11.0337 15.0746V18.9463C11.0337 20.8629 10.0725 21.8021 8.11086 21.8021ZM4.14839 13.6562C2.99104 13.6562 2.6968 13.9437 2.6968 15.0746V18.9463C2.6968 20.0771 2.99104 20.3646 4.14839 20.3646H8.11086C9.26821 20.3646 9.56245 20.0771 9.56245 18.9463V15.0746C9.56245 13.9437 9.26821 13.6562 8.11086 13.6562H4.14839Z'
        fill={color}
        stroke={color}
        strokeWidth={focused ? 1 : 0.5}
        strokeLinejoin='round'
        strokeLinecap='round'
      />
      <path
        d='M20.1073 17.4895H14.2224C13.8203 17.4895 13.4868 17.1637 13.4868 16.7708C13.4868 16.3778 13.8203 16.052 14.2224 16.052H20.1073C20.5094 16.052 20.8429 16.3778 20.8429 16.7708C20.8429 17.1637 20.5094 17.4895 20.1073 17.4895Z'
        fill={color}
        stroke={color}
        strokeWidth={focused ? 1 : 0.5}
        strokeLinejoin='round'
        strokeLinecap='round'
      />
      <path
        d='M17.1648 20.3645C16.7627 20.3645 16.4292 20.0387 16.4292 19.6458V13.8958C16.4292 13.5028 16.7627 13.177 17.1648 13.177C17.5669 13.177 17.9004 13.5028 17.9004 13.8958V19.6458C17.9004 20.0387 17.5669 20.3645 17.1648 20.3645Z'
        fill={color}
        stroke={color}
        strokeWidth={focused ? 1 : 0.5}
        strokeLinejoin='round'
        strokeLinecap='round'
      />
    </svg>
  );
}
